import React, { useEffect, useState } from "react";
import "./DashboardPage.css";

import DashboardGrid from "./DashboardGrid";
import DashboardNavbar from "./DashboardNavbar";

import AgendamentosService from "../../../services/AgendamentosService";
import CancelamentosService from "../../../services/CancelamentosService";
import ReceitasService from "../../../services/ReceitasService";
import FaltasService from "../../../services/FaltasService";

import atualizarAgendamentoPublicDTO from "../../../types/AgendamentoUpdatePublicDTO";

export default function DashboardPage() {
  const hoje = new Date().toISOString().split("T")[0];

  const [data, setData] = useState(hoje);
  const [agendamentos, setAgendamentos] = useState([]);
  const [selecionados, setSelecionados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState(null);
  const [retorno, setRetorno] = useState(null);

  const columns = [
    { header: "Data", field: "DATA" },
    {
      header: "Horário",
      field: "HORARIO",
      formatter: (v) => (v ? v.slice(0, 5) + "h" : "-"),
    },
    { header: "Cliente", field: "NOME" },
    { header: "Especialidade", field: "DESCRICAO" },
    { header: "Pago", field: "PAGO", 
      formatter: (_, row) => {
        if (row.PAGO) return "Pago";
        return "Não";
      },
    },
    {
      header: "Status",
      field: "IDAGENDAMENTO",
      formatter: (_, row) => {
        if (row.REALIZADO) return "Realizado"; 
        if (row.CANCELADA) return "Cancelado"; 
        if (row.FALTA) return "Falta";
        return "Agendado";
      },
    },
  ];

  async function carregarAgenda() {
      setLoading(true);
      setErro(null);
    try {
      const res = await AgendamentosService.getByData(data);
      setAgendamentos(Array.isArray(res) ? res : res?.data || []);
    } catch (error) {
      setErro(error.response?.data?.message || 'Erro ao carregar agendamento');
      setAgendamentos([]);
    } finally {
      setLoading(false);
      //setRetorno(null);
    }
  }

  useEffect(() => {
    carregarAgenda();
  }, [data]);

  //MARCAR COMO REALIZADO
  const marcarRealizado = async () => {
    try {
      for (const ag of selecionados) {
        await AgendamentosService.updateRealizado(ag.IDAGENDAMENTO, { REALIZADO: true });
      }
      setRetorno('Status atualizado com sucesso!');
      setSelecionados([]);
      carregarAgenda();

    } catch (error) {
      console.error(error);
      setErro(error.response?.data?.message || 'Erro ao atualizar Status');
    }
  };

  //MARCAR COMO CANCELADO
  const marcarCancelado = async () => {
    try {
      for (const ag of selecionados) {
        let motivo = 'Cancelado';
        const payload_cancelamento = { 
            IDAGENDAMENTO: ag.IDAGENDAMENTO,
            IDCADASTRO: ag.IDCADASTRO,
            DATA: ag.DATA,
            IDHORARIO: Number(ag.IDHORARIO),
            MOTIVO: motivo
		    };
        const response = await CancelamentosService.cancelarPublico(payload_cancelamento);

        console.log('Resposta:', response);
        if (!response.success) {
          throw new Error(response.error || 'Falha ao registrar cancelamento');
        }
      }
      setRetorno('Status atualizado com sucesso!');
      setSelecionados([]);
      carregarAgenda();
    } catch (error) {
      console.error(error);
      setErro(error.response?.data?.message || 'Erro ao atualizar Status');
    }
  };

  //MARCAR COMO FALTA 
  const marcarFalta = async () => {
    try {
      for (const ag of selecionados) {
        const response = await FaltasService.create(
          ag.IDAGENDAMENTO
        );
        console.log('Resposta:', response);
        if (!response.success) {
          throw new Error(response.error || 'Falha ao registrar falta');
        }
      }

      setRetorno('Status atualizado com sucesso!');
      setSelecionados([]);
      carregarAgenda();
  
    } catch (error) {
      console.error(error);
      setErro(
        error.response?.data?.message ||
        error.message ||
        'Erro ao atualizar Status'
      );
    }
  };

  //MARCAR COMO PAGO 
  const marcarPago = async () => {
    try {
      for (const ag of selecionados) {
        const response = await ReceitasService.create({
          DESCRICAO: 'A',
          IDORIGEM: ag.IDAGENDAMENTO,
          PAGO: 1
        });
    
        console.log('Resposta:', response);
        if (!response.success) {
          throw new Error(response.error || 'Falha ao registrar pagamento');
        }
      }

      setRetorno('Status atualizado com sucesso!');
      setSelecionados([]);
      carregarAgenda();
      
    } catch (error) {
      console.error(error);
        setErro(
          error.response?.data?.message ||
          error.message ||
          'Erro ao atualizar Status'
        );
      }
  };

  return (
    <div className="Dashboard-container">
      <div className="Dashboard-header">
        <input
          type="date"
          className="data"
          value={data}
          onChange={(e) => setData(e.target.value)}
        />
      </div>

      {retorno && (
        <div className="mensagem-sucesso">
          {retorno}
        </div>
      )}

      {erro && (
        <div className="mensagem-erro">
          {erro}
        </div>
      )}

      <DashboardGrid
        columns={columns}
        data={agendamentos}
        idField="IDAGENDAMENTO"
        loading={loading}
        onSelectionChange={setSelecionados}
      />

      <DashboardNavbar
        onRealizado={marcarRealizado}
        onPago={marcarPago}
        onCancelado={marcarCancelado}
        onFalta={marcarFalta}
        disabled={selecionados.length === 0 || loading}
      />
    </div>
  );
}
